import { Link } from "react-router-dom";
import { ArrowUpRight, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-brand-ink text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-20">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="inline-flex bg-white rounded-2xl px-4 py-2.5" data-testid="footer-logo">
              <img src="/yesai-logo.png" alt="YesAI — Your Everyday Smart AI" className="h-14 w-auto" />
            </div>
            <p className="mt-4 text-slate-400 text-sm leading-relaxed max-w-sm">
              Your Everyday Smart AI. Simple, practical AI apps that make daily business operations easy for small businesses.
            </p>
            <a
              href="mailto:hi@yesai.co.in"
              data-testid="footer-email-link"
              className="mt-4 inline-flex items-center gap-2 text-sm text-slate-300 hover:text-white transition-colors duration-200"
            >
              <Mail className="w-4 h-4 text-brand-red" />
              hi@yesai.co.in
            </a>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">Pages</p>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="text-slate-300 hover:text-white transition-colors duration-200" data-testid="footer-home-link">Home</Link></li>
              <li><Link to="/products" className="text-slate-300 hover:text-white transition-colors duration-200" data-testid="footer-products-link">Products</Link></li>
              <li><Link to="/industries" className="text-slate-300 hover:text-white transition-colors duration-200" data-testid="footer-industries-link">Industries</Link></li>
              <li><Link to="/book-demo" className="text-slate-300 hover:text-white transition-colors duration-200" data-testid="footer-book-demo-link">Book a Demo</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">Our Products</p>
            <Link
              to="/products"
              data-testid="footer-saleyes-link"
              className="group inline-flex items-center gap-2 bg-brand-inkCard hover:bg-slate-700 border border-slate-700 rounded-2xl px-5 py-4 transition-colors duration-200"
            >
              <span className="inline-flex bg-white rounded-full px-3 py-1.5"><img src="/saleyes-logo.png" alt="SaleYes" className="h-5 w-auto" /></span>
              <span className="text-slate-400 text-sm">Lead to sale, with in-app reminders</span>
              <ArrowUpRight className="w-4 h-4 text-slate-400 group-hover:text-brand-red group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200" />
            </Link>
            <Link
              to="/products"
              data-testid="footer-deliveryes-link"
              className="group mt-3 flex items-center gap-2 bg-brand-inkCard hover:bg-slate-700 border border-slate-700 rounded-2xl px-5 py-4 transition-colors duration-200"
            >
              <span className="inline-flex bg-white rounded-full px-3 py-1.5"><img src="/deliveryes-logo.png" alt="DeliverYes" className="h-5 w-auto" /></span>
              <span className="text-slate-400 text-sm">PO to delivery, made easy</span>
              <ArrowUpRight className="w-4 h-4 text-slate-400 group-hover:text-brand-red group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200" />
            </Link>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-slate-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} YesAI. All rights reserved.</p>
          <p className="font-mono text-xs text-slate-500 tracking-widest uppercase">Work Smarter. Grow Better.</p>
        </div>
      </div>
    </footer>
  );
}
